export default "__VITE_ASSET__7aa427b9__"